// extracted by mini-css-extract-plugin
export default {"label":"index_label__Nhddn","titleIcon":"index_titleIcon__HEK7X","card":"index_card__MeLmt"};